const initializeGladlyChat = () => {
  var _a;
  (_a = window["rei-gladly"]) == null ? void 0 : _a.init({
    appId: "rei.com-sales"
  });
};
const showGladlyChat = () => {
  var _a;
  (_a = window.Gladly) == null ? void 0 : _a.show();
};
export {
  initializeGladlyChat,
  showGladlyChat
};
//# sourceMappingURL=gladlyUtils.mjs.map
